var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{attrs:{"type":_vm.type,"height":_vm.height,"width":_vm.width,"options":_vm.chartOptions,"series":_vm.series,"ischart":_vm.ischart,"categorie":_vm.categories,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }